<template>
  <TicketBooking />
</template>

<script>
import TicketBooking from "./components/TicketBooking.vue";

export default {
  name: "App",
  components: {
    TicketBooking,
  },
};
</script>
